import { useQueryClient } from "react-query";
import { useParams } from "react-router-dom";
import API from "../../../services/API";
import { useContext } from "react";
import ToastContext from "../../../services/Context/ToastContext"
import useReorderQuestions from "./useReorderQuestions";
import { txt } from "../../../services/translation";

export default function useDeleteAuditQuestion(){

    const {id} = useParams()

    const {setToast} = useContext(ToastContext)

    const queryClient = useQueryClient()

    const queryKey = ['design', id, 'audit'];

    const reorderQuestions = useReorderQuestions()

    return (id) => {

        const ok = window.confirm(txt('confirmDeleteQuestion'));

        if(!ok) return false;
        
        const oldQuestions = [...queryClient.getQueryData(queryKey)];

        let newQuestions = [...queryClient.getQueryData(queryKey)].filter(c => c.id !== id);
        newQuestions = reorderQuestions(newQuestions);
        queryClient.setQueryData(queryKey, newQuestions);

        API.delete(`/audit/questions/${id}`)
            .then(() => API.put('/audit/questions/reorder', newQuestions))
            .catch(() => {
                queryClient.setQueryData(queryKey, oldQuestions)

                setToast({
                    severity: 'error',
                    message: txt('errorOccurred')
                })
            })
    }
}